import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import { GameCanvas } from '../components/GameCanvas'
import { GameHUD } from '../components/GameHUD'
import { GameMenu } from '../components/GameMenu'
import { useGameStore } from '../store/gameStore'

export default function GamePage() {
  const navigate = useNavigate()
  const [gameActive, setGameActive] = useState(false)
  const [showMenu, setShowMenu] = useState(true)
  const [gameOver, setGameOver] = useState(false)
  const [won, setWon] = useState(false)

  const handleStart = () => {
    setShowMenu(false)
    setGameOver(false)
    setWon(false)
    setGameActive(true)
    useGameStore.getState().startGame()
  }

  const handleGameOver = (victory: boolean) => {
    setGameOver(true)
    setWon(victory)
    setGameActive(false)
  }

  const handlePause = () => {
    useGameStore.getState().pauseGame()
    setGameActive(false)
    setShowMenu(true)
  }

  return (
    <div className="relative w-full h-full">
      <GameCanvas gameActive={gameActive} onGameOver={handleGameOver} />
      
      {gameActive && (
        <GameHUD onPause={handlePause} />
      )}

      <AnimatePresence>
        {showMenu && (
          <GameMenu
            isPaused={false}
            onResume={() => {
              useGameStore.getState().resumeGame()
              setGameActive(true)
              setShowMenu(false)
            }}
            onStart={handleStart}
            onQuit={() => navigate('/')}
            gameOver={gameOver}
            won={won}
          />
        )}
      </AnimatePresence>
    </div>
  )
}
